import _defineProperty from "/u01/jenkins/workspace/CloudFront-NodeJS/tgp-texasgov-ui/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/u01/jenkins/workspace/CloudFront-NodeJS/tgp-texasgov-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/u01/jenkins/workspace/CloudFront-NodeJS/tgp-texasgov-ui/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef, useState } from 'react';
export var TxInput = forwardRef(function (props, ref) {
  var label = props.label,
      errorMessage = props.errorMessage,
      hintMessage = props.hintMessage,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
      required = props.required,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      _props$optionalText = props.optionalText,
      optionalText = _props$optionalText === void 0 ? 'Optional' : _props$optionalText,
      icon = props.icon,
      inputProps = _objectWithoutProperties(props, ["label", "errorMessage", "hintMessage", "className", "hideLabel", "required", "type", "onFocus", "onBlur", "optionalText", "icon"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showHint = _useState2[0],
      setShowHint = _useState2[1];

  var extraClass = className ? " ".concat(className) : '';

  function onFocusInternal(e) {
    if (hintMessage) {
      setShowHint(true);
    }

    if (onFocus) {
      onFocus(e);
    }
  }

  function onBlurInternal(e) {
    setShowHint(false);

    if (onBlur) {
      onBlur(e);
    }
  }

  var inputClass = determineInputClass(errorMessage, showHint);
  return React.createElement("div", {
    className: 'tx-input' + (!!icon ? ' tx-input--icon' : '') + extraClass
  }, React.createElement("label", {
    className: "tx-input__label"
  }, React.createElement("span", {
    className: 'tx-input__label__text' + (hideLabel ? ' sr-only' : '')
  }, label, !required && React.createElement("span", {
    className: "tx-input__label__text__optional"
  }, optionalText)), React.createElement("input", _objectSpread({
    className: inputClass,
    required: required,
    type: type,
    ref: ref,
    onFocus: onFocusInternal,
    onBlur: onBlurInternal
  }, inputProps)), icon && React.createElement("div", {
    className: "tx-input__label__icon"
  }, icon)), errorMessage && React.createElement("div", {
    className: "tx-input__error-message",
    "data-testid": "error-msg"
  }, errorMessage), hintMessage && !errorMessage && showHint && React.createElement("div", {
    className: "tx-input__hint-message",
    "data-testid": "hint-msg"
  }, hintMessage));
});

function determineInputClass(errorMessage, showHint, hasIcon) {
  var classBase = 'tx-input__label__input';

  if (hasIcon) {
    classBase += ' tx-input__label__input--error';
  }

  if (errorMessage) {
    classBase += ' tx-input__label__input--error';
  } else if (showHint) {
    classBase += ' tx-input__label__input--hint';
  }

  return classBase;
}